import * as Zod from 'zod';

import { IImportUserHeader } from 'graphql/types';
import { translate } from 'utils/i18n';

export const userImportFormValidator = Zod.object({
    includeHeaders: Zod.boolean(),
    organisationEmail: Zod.boolean(),
    trainingEmail: Zod.boolean(),
    headersOrder: Zod.array(Zod.string()),
})
    .refine(
        // Ensure each header (built-in or extra category) is used at most once.
        // Multiple Ignore columns are allowed.
        (data) => {
            const nonIgnoreHeaders = data.headersOrder.filter(
                (h) => h !== IImportUserHeader.Ignore
            );

            return new Set(nonIgnoreHeaders).size === nonIgnoreHeaders.length;
        },
        {
            message: translate('userImportModal.validation.duplicateHeaders'),
            path: ['headersOrder'],
        }
    )
    .refine(
        // Ensure the selected headers include at least an email and a name
        // (either "Name", "FirstName", or "LastName")
        (data) => {
            const headers = data.headersOrder;
            const hasEmail = headers.includes(IImportUserHeader.Email);
            const hasName =
                headers.includes(IImportUserHeader.Name) ||
                headers.includes(IImportUserHeader.FirstName) ||
                headers.includes(IImportUserHeader.LastName);

            return hasEmail && hasName;
        },
        {
            message: translate('userImportModal.validation.requiredHeaders'),
            path: ['headersOrder'],
        }
    );
